import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sbw-select-demo',
    templateUrl: './select-demo.component.html'
})
export class SelectDemoComponent implements OnInit {
    public selectItems = [new MyDemoModel('value1', 'text 1'), new MyDemoModel('value2', 'text 2'), new MyDemoModel('value3', 'text 3')]
    public selectedItem: string = 'value2'
    public blankSelectedItem: string
    public placeholderSelectedItem: string = null

    public selectDemoObjects = [
        { id: 'obj1', selectedItem: new MyDemoModel('value2', 'text 2') },
        { id: 'obj2', selectedItem: new MyDemoModel('value1', 'text 1') },
        { id: 'obj3', selectedItem: new MyDemoModel('value3', 'text 3') }
    ]

    public multiSelectionChange(o, e) {
        o.selectedItem = { ...this.selectItems.find(x => x.code === e) } // important to clone it to break the reference
    }
    constructor() { }

    ngOnInit() {
    }

}

export class MyDemoModel {
    constructor(
        public code: string,
        public description: string) { }
}
